import { Component, Directive, ContentChildren, QueryList } from '@angular/core';

// content slots

// slot / menu
@Directive({
  selector: 'layout-side-menu'
})
export class LayoutSideMenuDirective {}

// slot / body content
@Directive({
  selector: 'layout-content'
})
export class LayoutContentDirective {}

// component
@Component({
  selector: 'spark-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {

  @ContentChildren(LayoutSideMenuDirective, { descendants: false })
  sideMenuChildren?: QueryList<LayoutSideMenuDirective>;

  public get hasSideMenu(): boolean {
    return !!this.sideMenuChildren?.length;
  }
}
